import { Component, OnInit } from "@angular/core";
import { UserManager } from "../../../business/managers/user.manager";
import { CHANGE_PASSWORD_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidatorHelper } from "../../../crossconcern/helpers/validators/formvalidator.helper";
import { AppComponent } from "../../app.component";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { finalize } from "rxjs/operators";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { PRIVATE_NURSERY_LIST_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";

@Component({
    selector: CHANGE_PASSWORD_SELECTOR,
    styles: [],
    templateUrl: "changepassword.component.html"
})
export class ChangePasswordComponent extends BaseComponent implements OnInit {

    public changePasswordForm: FormGroup;

    constructor(protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        private userManager: UserManager,
        protected formBuilder: FormBuilder,
        protected validator: FormValidatorHelper,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
        this.changePasswordForm = formBuilder.group({
            "oldPassword": [
                null, ([
                    Validators.required, validator.emailValidator
                ])
            ],
            "newPassword": [
                null, ([
                    Validators.required, validator.passwordValidator
                ])
            ],
            "confirmNewPassword": [
                null, ([
                    Validators.required, validator.passwordMatchValidator
                ])
            ]
        });
    }

    public ngOnInit() {
        //
    }

    public onSubmit() {
        this.appComponent.startLoading();
        this.userManager.changePassword(
            this.changePasswordForm.value.oldPassword,
            this.changePasswordForm.value.newPassword)
            .pipe(
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe(
                () => {
                    this.userManager.logout();
                    this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE);
                });
    }
}
